<template>
  <div class="" style="width: 100%;">
         <v-row>
      <v-col>
    <v-container fluid>
      <v-row>
        <v-col class='col-md-8 d-flex flex-row align-center flex-wrap' style="row-gap: 8px;">
          <v-btn text class="mx-2" @click="()=>{this.$router.push({path: '/purchasing'})}">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          <h1>{{singular}} #{{purchaseOrder.id}}</h1>
          <v-btn color="warning" class="mr-2" @click="openVoidDialog()" :disabled="purchaseOrder.status===-1">Void</v-btn>
          <v-btn
            v-if="purchaseOrder.status === 1 && !purchaseOrder.Expense"
            color="success"
            class="mr-2"
            @click="payInvoiceDialog = true"
          >Pay Invoice</v-btn>
          <v-btn
            v-if="purchaseOrder.status === 1 && purchaseOrder.Expense"
            color="primary"
            class="mr-2"
            @click="$router.push({ path: `/expenses/view/${purchaseOrder.Expense.id}` })"
          >View Payment</v-btn>
          <div v-if="getGlobalValue('VEC_PRINT_SYSTEM_CONTAINER_PO')" style="width: 100%;">
            <dynamicButtonContainer :containerId="`${getGlobalValue('VEC_PRINT_SYSTEM_CONTAINER_PO')}`" :data="{status: purchaseOrder.status, id1: $route.params.id}" style="width: 100%;"/>
          </div>
        </v-col>
        <v-col class="col-md-4">
          <v-progress-circular
            indeterminate
            color="green"
            v-if="loader"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row v-if="purchaseOrder.id">
        <v-col cols="12">
          <v-card outlined>
            <v-card-text>
              <VarionScannerButton target-type="purchaseOrder" :target-id="purchaseOrder.id" @complete="$refs.poAttachments && $refs.poAttachments.refresh()" />
              <div class="mt-3">
                <AttachmentsPanel ref="poAttachments" target-type="purchaseOrder" :target-id="purchaseOrder.id" />
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex flex-column">
          <span v-if="purchaseOrder.createdAt">Created By {{lookupUsername(purchaseOrder.createdBy)}} at {{utils.formatDate(purchaseOrder.createdAt, 'withTime')}}</span>
          <span v-if="purchaseOrder.sealedAt">Sealed By {{lookupUsername(purchaseOrder.sealedBy)}} at {{utils.formatDate(purchaseOrder.sealedAt, 'withTime')}}</span>
          <span v-if="purchaseOrder.voidedAt">Voided By {{lookupUsername(purchaseOrder.voidedBy)}} at {{utils.formatDate(purchaseOrder.voidedAt, 'withTime')}}</span>
        </v-col>
      </v-row>
      <v-row v-if="!loader">
        <v-col cols="12" md="8" style="background-color: rgba(0,0,0,0.05); border-radius: 10px; padding: 20px; border-radius: 10px; margin-top: 20px; border: 1px solid grey;">
          <div class="d-flex flex-column">
            <div style="width: 100%;">
              <!-- header -->
              <div style="width: 100%; margin-top: 10px; gap: 16px;" class="d-flex flex-row flex-wrap justify-space-between">
                <div class="d-flex flex-column" style="flex: 1 1 130px;">
                  <span>
                    <h2>Supplier</h2>
                  </span>
                  <div class="d-flex flex-column">
                    <h3>{{purchaseOrder.supplierInfo.name}}</h3>
                    <h4>{{purchaseOrder.supplierInfo.contactName}}</h4>
                    <h4>{{purchaseOrder.supplierInfo.address}}</h4>
                    <h4>{{purchaseOrder.supplierInfo.phone}}</h4>
                    <h4>{{purchaseOrder.supplierInfo.email}}</h4>
                  </div>
                </div>
                <div class="d-flex flex-column" style="flex: 1 1 130px;">
                  <span>
                    <h2>Ship To</h2>
                  </span>
                  <div class="d-flex flex-column">
                    <h3>{{purchaseOrder.shipToInfo.name}}</h3>
                    <h4>{{purchaseOrder.shipToInfo.address}}</h4>
                    <h4>{{purchaseOrder.shipToInfo.phone}}</h4>
                    <h4>{{purchaseOrder.shipToInfo.email}}</h4>
                  </div>
                </div>
              </div>
              <hr class="mt-5 mb-3">
            </div>
            <div>
              <!-- body -->
                <v-simple-table style="height: 100%; background-color: rgba(0,0,0,0)">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-center">
                      QTY
                    </th>
                    <th class="text-center">
                      ID
                    </th>
                    <th class="text-center" style="min-width: 220px;">
                      Name
                    </th>
                    <th class="text-center">
                      SKU
                    </th>
                    <th class="text-center">
                      Unit Price
                    </th>
                    <th class="text-center">
                      Profit Margin
                    </th>
                    <th class="text-center">
                      Regular Price
                    </th>
                    <th class="text-right">
                      Total
                    </th>
                    <th class="text-right">
                      QTY Received
                    </th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in purchaseOrder.PurchaseOrderLineItems" :key="item.id">
                      <td class="text-center">{{utils.pff(item.quantity)}}</td>
                      <td class="text-center">
                        <router-link :to="'/products/view/'+item.productId">{{item.productId}}</router-link>
                      </td>
                      <td class="text-center">
                        <span>{{item.productName}}</span>
                        <span v-if="item.metadata.customName && item.productName!==item.metadata.customName"><br><b>SIN: </b>{{item.metadata.customName}}</span>
                      </td>
                      <td class="text-center">{{item.sku}}</td>
                      <td class="text-center">{{utils.formatCurrency(item.unitPrice)}}</td>
                      <td class="text-center"><span v-if="item.metadata.profitMargin">{{item.metadata.profitMargin}}%</span><span v-else>No Data</span></td>
                      <td class="text-center"><span v-if="item.metadata.regularPrice">{{utils.formatCurrency(item.metadata.regularPrice)}}</span><span v-else>No Data</span></td>
                      <td class="text-right">{{utils.formatCurrency(item.metadata.lineTotal||0)}}</td>
                      <td class="text-right">{{item.receivedTotal||0}}/{{utils.pff(item.quantity)}}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
            <div class="d-flex flex-row justify-end" style="width: 100%; margin-top: 10px;">
              <div style="width: 120px; padding-right:20px;" class="d-flex flex-column align-end">
                <span class="d-flex flex-column align-end">
                  <span>
                    <span class="text-h5">Subtotal</span>
                    <span class="text-h4 ml-5">{{utils.formatCurrency(purchaseOrder.subtotal)}}</span>
                  </span>
                  <span>
                    <span class="text-h5">Total</span>
                    <span class="text-h4 ml-5">{{utils.formatCurrency(purchaseOrder.grandTotal)}}</span>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4" v-if="getGlobalValue('VEC_ADMIN_INCLUDE_RR_IN_PO')==='true'" >
          <v-row>
            <v-col class="d-flex flex-row align-center">
              <h1>{{this.secondaryPlural}}</h1>
              <v-btn
                  v-if="purchaseOrder.status===1"
                  class="mx-2"
                  fab
                  small
                  dark
                  color="info"
                  @click="createA"
              >
                <v-icon dark>
                  mdi-plus
                </v-icon>
              </v-btn>
              <v-progress-circular
                  indeterminate
                  color="green"
                  v-if="loader"
                  style="margin-left: 10px;"
              ></v-progress-circular>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table mobile-breakpoint="0"
                  :headers="headers"
                  :items="receivingReports"
                  :items-per-page="-1"
                  class="elevation-1"
                  @click:row="rowClick"
                  @mousedown:row="rowMiddleClick"
              >
                <template v-slot:item.sealedAt="{ item }">
                  <span>{{utils.formatDate(item.sealedAt)}}</span>
                </template>
                <template v-slot:item.sealedBy="{ item }">
                  <span>{{lookupUsername(item.sealedBy)}}</span>
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip :color="utils.getRRStatusColor(item.status)">{{utils.parseRRStatus(item.status)}}</v-chip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
      </v-row>
    </v-container>
      </v-col>
     </v-row>

    <v-dialog v-model="payInvoiceDialog" max-width="490">
      <v-card>
        <v-card-title class="text-h5">Pay Invoice for PO #{{ purchaseOrder.id }}?</v-card-title>
        <v-card-text>
          This will create a new expense pre-populated with the details from this Purchase Order.
          <div class="mt-3">
            <div><strong>Supplier:</strong> {{ purchaseOrder.supplierInfo && purchaseOrder.supplierInfo.name }}</div>
            <div><strong>Amount:</strong> {{ utils.formatCurrency(purchaseOrder.grandTotal) }}</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="info" text @click="payInvoiceDialog = false">Cancel</v-btn>
          <v-btn color="success" :loading="payInvoiceLoading" @click="confirmPayInvoice">Create Expense</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="createDialog.isOpen" max-width="490">
      <v-card>
        <v-card-title class="text-h5">
          Create New Receiving Report
        </v-card-title>
        <v-card-actions>
          <v-btn color="error" text @click="cancelCreate">
            Cancel
          </v-btn>
          <v-btn color="success" @click="createB">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="voidDialog"
        max-width="490"
    >
      <v-card>
        <v-card-title class="text-h5">
          Void this Purchase Order?
        </v-card-title>
        <v-card-text>You will not be able to edit it once voided.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="info"
              @click="voidDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
              color="error"
              @click="confirmVoid()"
          >
            Void
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
  import axios from 'axios';
  import {mapGetters} from "vuex";
  import utils from "../../plugins/helpers"
  import dynamicButtonContainer from './../../components/dynamicButtonContainer.vue';
  import VarionScannerButton from './../../components/VarionScannerButton.vue';
  import AttachmentsPanel from './../../components/AttachmentsPanel.vue';
  export default {
    components: {
      dynamicButtonContainer,
      VarionScannerButton,
      AttachmentsPanel
    },
    data () {
      return {
        utils: utils,

        loader: false,

        snackObj: {
          state: false,
          color: '',
          text: ''
        },

        max25chars: v => v.length <= 25 || 'Input too long!',
        data: {},
        userTypes: [],
        products: [],

        singular: "Purchase Order",
        singularLower: "purchaseorder",
        plural: "Purchase Orders",
        pluralLower: "purchaseorders",

        secondarySingular: "Receiving Report",
        secondarySingularLower: "receivingreport",
        secondaryPlural: "Receiving Reports",
        secondaryPluralLower: "receivingreports",

        suppliers: [],
        supplierProducts: [],
        purchaseOrder: {
          sealedDocument: {},
          PurchaseOrderLineItems: [],
          subtotal: 0, 
          grandTotal: 0, 
          supplierInfo: {}, 
          shipToInfo: {
            companyName: "",
            address: "",
            phone: '',
            email: '',
        }},

        receivingReports: [],

        voidDialog: false,
        payInvoiceDialog: false,
        payInvoiceLoading: false,

        headers: [
          { text: 'ID', align: 'start', sortable: true, value: 'id' },
          { text: '# of Items', align: 'start', sortable: true, value: 'itemCount' },
          { text: 'Date Sealed', align: 'start', sortable: true, value: 'sealedAt' },
          { text: 'Sealed By', align: 'start', sortable: true, value: 'sealedBy' },
          { text: 'Status', align: 'start', sortable: true, value: 'status' },
        ],

        valid: false,
        taxRate: 10,
        created: false,
        isNewPO: "",
        supplierEditing: false,
        shipToEditing: false,
        tempSupplierInfo: {},
        tempShipToInfo: {},
        renderKey: 0,
        deleteDialog: false,
        createDialog: {
          isOpen: false,
          confirmed: false
        }
      }
    },
    async mounted(){
      try{
        this.loader = true;

        let po = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/withReports/${this.$route.params.id}`);
        if(po.data.error) throw po.data.error
        this.purchaseOrder = po.data.data
        this.purchaseOrder.PurchaseOrderLineItems.sort((a,b) => (a.createdAt > b.createdAt) ? 1 : ((b.createdAt > a.createdAt) ? -1 : 0))

        this.receivingReports = this.purchaseOrder.ReceivingReports;

        this.updateTotals()
      }
      catch (error) {
        console.error(error)
        this.snack(error.msg || error.msg?.message || error, "error");
      }
      finally {
        this.loader = false;
      }
    },
    computed: {
      ...mapGetters(['getEndpoint', "getId", 'lookupUsername', 'getGlobalValue'])
    },
    methods: {
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.state = true;
        this.snackObj.color = color;
      },
      updateTotals(){
        this.purchaseOrder.PurchaseOrderLineItems.forEach(item=>item.metadata.lineTotal = utils.pff(item.quantity)*item.unitPrice)
        this.purchaseOrder.subtotal = this.purchaseOrder.PurchaseOrderLineItems.reduce((a,x)=>a+x.metadata.lineTotal,0)
        // this.purchaseOrder.grandTotal = ((this.taxRate/100)*this.purchaseOrder.subtotal) + this.purchaseOrder.subtotal
        this.purchaseOrder.grandTotal = this.purchaseOrder.subtotal
        this.$forceUpdate()
      },
      rowClick(row){
        this.$router.push({ path: `/receiving/view/${row.id}`})
      },
      async rowMiddleClick(event, row){
        if(!row.item) return;
        row = row.item;

        if (event.button === 1) {
          event.preventDefault();
          this.utils.openInNewTab(this.$router,`/receiving/view/${row.id}`)
        }
      },
      createA(){
        this.createDialog.isOpen = true
      },
      cancelCreate(){
        this.createDialog.isOpen = false;
      },
      async createB(){
        try {
          let res = await axios.post(`${this.getEndpoint}/api/${this.secondaryPluralLower}`, {poId: this.purchaseOrder.id, supplierId: this.purchaseOrder.supplierId})
          if(res.data.error) throw res.data.error
          this.createDialog.isOpen = false
          await this.$router.push({ path: `/receiving/view/${res.data.data.id}`})
        } catch (error) {
         console.error(error)
          this.snack(error.msg || error.msg?.message || error, "error");
         this.createDialog.isOpen = false
        }
      },
      async confirmPayInvoice() {
        try {
          this.payInvoiceLoading = true;
          const today = new Date().toISOString().slice(0, 10);
          const payload = {
            name: `Invoice – PO #${this.purchaseOrder.id}${this.purchaseOrder.supplierInfo?.name ? ' · ' + this.purchaseOrder.supplierInfo.name : ''}`,
            supplierId: this.purchaseOrder.supplierId || null,
            amount: this.purchaseOrder.grandTotal || 0,
            paymentDate: today,
            invoiceId: this.purchaseOrder.id,
            status: 0,
            notes: `Auto-created from Purchase Order #${this.purchaseOrder.id}.`,
          };
          let res = await axios.post(`${this.getEndpoint}/api/expenses`, payload);
          if (res.data.error) throw res.data.error;
          this.payInvoiceDialog = false;
          await this.$router.push({ path: `/expenses/view/${res.data.data.id}` });
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error.message || error, 'error');
        } finally {
          this.payInvoiceLoading = false;
        }
      },
      openVoidDialog(){
        this.voidDialog = true
      },
      async confirmVoid(){
        try {
          this.voidDialog = false
          let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/void/${this.purchaseOrder.id}`)
          if(res.data.error) throw res.data.error

          this.purchaseOrder = res.data.data;

        } catch (error) {
          console.error(error)
          this.snack(error.msg || error.msg?.message || error, "error");
        }
      },
    }
  }
</script>
